import { useRecordContext } from 'react-admin';
import { useRunRequest } from '@/hooks';
import { TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { FCRAWorkerCheckRecord } from '@/types/turn-api';

const useController = () => {
  const record = useRecordContext<FCRAWorkerCheckRecord.MVRLicense>();
  const { runRequest } = useRunRequest();

  const updateLicense = async (license_number: string) =>
    await runRequest({
      fetchType: 'CREATE',
      resource: TurnResourcesEnum.FcraWorkers,
      params: {
        id: record.id,
        target: TurnTargetsEnum.UpdateWorkerMvrLicense,
        data: { license_number },
      },
      mode: 'notify',
    });

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') updateLicense(event.currentTarget.value);
  };

  return {
    licenseNumber: record?.license_number,
    onKeyDown,
  };
};

export default useController;
